import React from "react";
import { motion } from "framer-motion";

// Masked line reveal for hero
export const MaskLine = ({ children, delay = 0, className = "" }) => (
  <span className="block overflow-hidden">
    <motion.span
      className={`block ${className}`}
      initial={{ y: "110%" }}
      animate={{ y: 0 }}
      transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1], delay }}
    >
      {children}
    </motion.span>
  </span>
);

// Scroll reveal wrapper
export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.6, ease: "easeOut", delay }}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ children }) => (
  <div className="flex items-center gap-3 mb-5">
    <span className="w-8 h-px bg-blue-500" />
    <span className="text-xs uppercase tracking-[0.25em] font-mono text-blue-400">{children}</span>
  </div>
);
